import type { LogAddinsTelemetryEventParams } from 'owa-analytics-types';
import { getAnalyticsAddon } from 'owa-analytics-addons';

export function logAddinsTelemetryEvent(...args: LogAddinsTelemetryEventParams): void {
    getAnalyticsAddon('LogAddinsTelemetryEvent')?.executeWhenReady(...args);
}
